import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_ACADEMIC_CYCLE_CONFIGS, 
    ADD_NEW_ACADEMIC_CYCLE_CONFIG, 
    UPDATE_ACADEMIC_CYCLE_CONFIG, 
    DELETE_ACADEMIC_CYCLE_CONFIG 
} from "./actionTypes";

import {
    getAcademicCycleConfigsSuccess,
    getAcademicCycleConfigsFail,
    addAcademicCycleConfigSuccess,
    addAcademicCycleConfigFail,
    updateAcademicCycleConfigSuccess,
    updateAcademicCycleConfigFail,
    deleteAcademicCycleConfigSuccess,
    deleteAcademicCycleConfigFail,
   
} from "./actions"

import {
    getAcademicCycleConfigs ,
    addNewAcademicCycleConfig,
    updateAcademicCycleConfig,
    deleteAcademicCycleConfig,
   
} from "helpers/academic-cycle-configs/academic_cycle_configs_backend_helper";
import { toast } from "react-toastify";

function* fetchAcademincCycleConfigs() {
    try {
        const response = yield call(getAcademicCycleConfigs)
        yield put(getAcademicCycleConfigsSuccess(response))
    } catch (error) {
        yield put(getAcademicCycleConfigsFail(error))
    }
}

function* onAddNewAcademicCycleConfig({ payload }) {
    try {

        
        const response = yield call(addNewAcademicCycleConfig, payload)

        yield put(addAcademicCycleConfigSuccess(response.academicCycleConfig))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addAcademicCycleConfigFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateAcademicCycleConfig({ payload}) {
    try {
        const response = yield call(updateAcademicCycleConfig, payload)
        yield put(updateAcademicCycleConfigSuccess(response.academicCycleConfig))
        //yield put(updateAcademicCycleConfigSuccess(response))

        // 🔹 FORCE LE RECHARGEMENT COMPLET
        // Comme ça, toutes les autres années repassent à "Non" (0)
        //yield put(getAcademicCycleConfigs());


        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateAcademicCycleConfigFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteAcademicCycleConfig({ payload: data }) {

    try {
        const response = yield call(deleteAcademicCycleConfig, data)
        yield put(deleteAcademicCycleConfigSuccess(response.academicCycleConfigId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteAcademicCycleConfigFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* academicCycleConfigSaga() {
    yield takeEvery(GET_ACADEMIC_CYCLE_CONFIGS, fetchAcademincCycleConfigs)
    yield takeEvery(ADD_NEW_ACADEMIC_CYCLE_CONFIG, onAddNewAcademicCycleConfig)
    yield takeEvery(UPDATE_ACADEMIC_CYCLE_CONFIG, onUpdateAcademicCycleConfig)
    yield takeEvery(DELETE_ACADEMIC_CYCLE_CONFIG, onDeleteAcademicCycleConfig)
}

export default academicCycleConfigSaga;